import { Directive, HostListener, HostBinding, EventEmitter, Output, ElementRef } from '@angular/core';

@Directive({
    selector: '[dnd]',
    standalone: false
})
export class DndDirective {
  @Output() private filesChangeEmiter: EventEmitter<FileList> = new EventEmitter();

  constructor(private el: ElementRef) {}
  @HostBinding('style.background-color') private background = '#fff';
  @HostBinding('style.border') private border = '2px solid white';

  private dragEnter(evt) {
    evt.preventDefault();
    evt.stopPropagation();
  }

  @HostListener('dragover', ['$event']) public onDragOver(evt) {
    this.dragEnter(evt);
    this.background = '#e8f0fe';
    this.border = '2px solid #4285f4';
  }

  @HostListener('dragenter', ['$event']) public onDragEnter(evt) {
    this.dragEnter(evt);
    this.background = '#e8f0fe';
    this.border = '2px solid #4285f4';
  }

  @HostListener('dragleave', ['$event']) public onDragLeave(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.background = '#fff';
    this.border = '2px solid white';
  }

  @HostListener('drop', ['$event']) public onDrop(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    const files = evt.dataTransfer.files;
    if (files.length > 0) {
      this.filesChangeEmiter.emit(evt);
    }
    this.background = '#fff';
    this.border = '2px solid white';
  }
}
